import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollapseRow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.6666 8.00004C14.6666 4.32004 11.6799 1.33337 7.99992 1.33337C4.31992 1.33337 1.33325 4.32004 1.33325 8.00004C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00004ZM2.66659 8.00004C2.66659 5.05337 5.05325 2.66671 7.99992 2.66671C10.9466 2.66671 13.3333 5.05337 13.3333 8.00004C13.3333 10.9467 10.9466 13.3334 7.99992 13.3334C5.05325 13.3334 2.66659 10.9467 2.66659 8.00004ZM10.6666 8.00004L7.99992 10.6667L7.05992 9.72671L8.11325 8.66671H5.33325V7.33337H8.11325L7.05325 6.27337L7.99992 5.33337L10.6666 8.00004Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCollapseRow);
export { ForwardRef as ReactComponent };
